import {ServiceNumber, Contact, ServiceNumberData} from '@gt-api';
import {GtPhoneNumberUtil} from '../shared/utils/gt-phone-number.util';

export enum ContactType {
  ServiceNumber,
  EndUser, // db contact type = 0
  ExternalEndUser, // db contact type = 0 w/inbound and outbound triggering set to 0
  InternalContact, // db contact type = 1 w/short number
  Contact, // db contact type = 2
  Favorite
}

export class StatusEntry {
  statusText: string;
  statusColor: StatusColor;
  statusIcon: string;
}

export enum StatusColor {
  STATUS_GREEN = 'color-green',
  STATUS_YELLOW = 'color-yellow',
  STATUS_GRAY = 'color-gray',
  STATUS_RED = 'color-red',
  STATUS_BLACK = 'color-black'
}

export const EUStates: {[stateID: number]: StatusEntry} = {
  '-99': {statusText: 'eu_states.unknown', statusColor: StatusColor.STATUS_GRAY, statusIcon: 'help_outline'},
  '-2': {statusText: 'eu_states.roaming', statusColor: StatusColor.STATUS_GRAY, statusIcon: 'flight'},
  '-1': {statusText: 'eu_states.detached', statusColor: StatusColor.STATUS_GRAY, statusIcon: 'phonelink_erase'},
  0: {statusText: 'eu_states.available', statusColor: StatusColor.STATUS_GREEN, statusIcon: 'person'},
  1: {statusText: 'eu_states.available', statusColor: StatusColor.STATUS_GRAY, statusIcon: 'person'},
  2: {statusText: 'eu_states.calling', statusColor: StatusColor.STATUS_YELLOW, statusIcon: 'vibration'},
  3: {statusText: 'eu_states.conversation', statusColor: StatusColor.STATUS_RED, statusIcon: 'phone_in_talk'},
  7: {statusText: 'eu_states.conversation', statusColor: StatusColor.STATUS_RED, statusIcon: 'phone_in_talk'}
};

export abstract class AbstractContactModel {
  abstract backendModel: any;
  type: ContactType;
  id: number;
  status: string;
  statusIcon: string;
  statusColor = StatusColor.STATUS_GRAY;
  statusImage: string;
  name: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  oname: string;
  login: string;
  email: string = null;
  department: string = null;
  shortNumber: string = null;
  imageId: number;
  favourite = false;
  administrator = false;
  blocked = false;

  isEndUser(): boolean {
    return this.type === ContactType.EndUser;
  }

  isExternalEnduser(): boolean {
    return this.type === ContactType.ExternalEndUser;
  }

  isInternalContact(): boolean {
    return this.type === ContactType.InternalContact;
  }

  isContact(): boolean {
    return this.type === ContactType.Contact;
  }

  isServiceNumber(): boolean {
    return this.type === ContactType.ServiceNumber;
  }

  isStored(): boolean {
    return !(this.type === ContactType.Contact && this.id < 1);
  }

  abstract getBackendModel();

  getFormattedNumber(): string {
    return GtPhoneNumberUtil.toDisplay(this.phoneNumber);
  }

  constructor() {}

  toString(): string {
    return `${this.name} - ${this.phoneNumber}`;
  }
}
